<template>
  <div>
    <div>
      <el-button type="primary" v-if="!isSound" @click="recStart"
        >开始录音</el-button
      >
      <el-button type="primary" v-else @click="recStop">停止录音</el-button>
      <el-button type="primary" @click="recPlay">播放录音</el-button>
      <span>录音时长:{{ audioDuration }}s</span> 
    </div>
  </div>
</template>
<script>
import Recorder from "recorder-core";

// 引入mp3格式支持文件；如果需要多个格式支持，把这些格式的编码引擎js文件放到后面统统引入进来即可
import "recorder-core/src/engine/mp3";
import "recorder-core/src/engine/mp3-engine";
// 录制wav格式的用这一句就行
import "recorder-core/src/engine/wav";

export default {
  name: "sound",
  components: {},
  props: {},
  data() {
    return {
      localUrl: "", // 本地试听录音文件
      isSound: false, // 是否录制完成
      isStop: false, // 是否停止录制
      audioDuration: 0, //录音时长
      refName: "",
    };
  },
  props: ["str"],
  watch: {
    str: {
      handler(newVal, oldVal) {
        this.refName = newVal;
        var audioData = JSON.parse(localStorage.getItem(newVal));
        console.log(audioData, "audioData6666");
        if (audioData) {
          this.audioDuration = audioData.duration;
        }
      },
      immediate: true,
    },
  },
  computed: {},
  mounted() {},
  methods: {
    // 开始录音
    recStart() {
      this.isSound = true;
      // 创建录音对象
      this.rec = Recorder({
        type: "mp3", // 录音格式，可以换成wav等其他格式
        sampleRate: 16000, // 录音的采样率，越大细节越丰富越细腻
        bitRate: 16, // 录音的比特率，越大音质越好
        onProcess: (
          buffers,
          powerLevel,
          bufferDuration,
          bufferSampleRate,
          newBufferIdx,
          asyncEnd
        ) => {
          // 录音实时回调，大约1秒调用12次本回调
          this.audioDuration = bufferDuration / 1000;
        },
      });

      // 打开录音，获得权限
      this.rec.open(
        () => {
          console.log("录音已打开");

          this.rec.start();
          this.$message.success("已开始录音");
        },
        (msg, isUserNotAllow) => {
          // 用户拒绝了录音权限，或者浏览器不支持录音
          this.isSound = false;
          this.$message.error((isUserNotAllow ? "UserNotAllow，" : "") + msg);
        }
      );
      if (!this.rec) {
        this.isSound = false;
        this.$message.error("未打开录音");
        return;
      }
    },
    // 结束录音
    recStop() {
      // 控制频繁点击暂停录制按钮导致报错问题
      if (this.isStop) {
        return;
      }
      if (!this.rec) {
        this.isSound = false;
        this.$message.error("未打开录音");
        return;
      }
      // envInLast 录制结束时间   envInFirst 录制开始时间
      var time = this.rec.envInLast - this.rec.envInFirst;
      console.log("sound 【共录制time:", time, "ms】");
      this.isStop = true;
      this.rec.stop(
        (blob, duration) => {
          this.$emit("loadingTrue");
          // blob就是我们要的录音文件对象，可以上传，或者本地播放
          console.log(blob,'blob6666666666666')
          this.recBlob = URL.createObjectURL(blob);
          localStorage.setItem(
            this.refName,
            JSON.stringify({ 
              duration: this.audioDuration,
              src: this.recBlob,
            })
          );
          // 简单利用URL生成本地文件地址，此地址只能本地使用，比如赋值给audio.src进行播放，赋值给a.href然后a.click()进行下载（a需提供download="xxx.mp3"属性）
          this.localUrl = this.recBlob;
          // console.log('录音成功blob', blob)
          console.log("localUrl", this.localUrl);
          // console.log('时长:' + duration + 'ms')

          // this.upload(blob, this.localUrl) // 把blob文件上传到服务器（请求后台接口）
        },
        (err) => {
          console.error("结束录音出错：" + err);
          this.isSound = false;
          this.$message.error("结束录音出错：" + err);
          this.reset("now");
        }
      );
    },
    // 上传录音
    upload(blob, localUrl) {
      var params = new FormData();
      params.append("file", blob);
      params.append(
        "token",
        decodeURIComponent(
          JSON.parse(window.localStorage.getItem("token")).value
        )
      );
    },
    // 本地试听
    recPlay() {
      try {
        // 从localStorage获取录音数据
        var audioData = JSON.parse(localStorage.getItem(this.refName));
        if (audioData) {
          // 创建audio元素并设置属性
          var audio = this.createAudioElement(audioData.src);

          // 播放音频
          audio.play().catch((error) => {
            console.error("播放录音时出错：", error);
            this.$message.error("播放录音失败，请确保在用户的交互操作下播放。");
          });

          // 监听音频播放结束事件
          audio.addEventListener("ended", () => {
            console.log(audio.src, "audio.src结束了。。。。。。。");
            // URL.revokeObjectURL(audio.src);
            this.removeAudioElement(audio); // 从DOM中移除audio元素
          });

          // 更新音频时长显示
          this.audioDuration = audioData.duration;
        } else {
          console.error("未找到录音数据");
        }
      } catch (error) {
        console.error("处理录音播放时出错：", error);
      }
    },

    // 创建audio元素并添加到DOM中
    createAudioElement(src) {
      var audio = document.createElement("audio");
      audio.controls = true;
      audio.src = src;
      document.body.appendChild(audio);
      return audio;
    },

    // 从DOM中移除audio元素
    removeAudioElement(audio) {
      if (audio && audio.parentNode) {
        audio.parentNode.removeChild(audio);
      }
    },
    // recPlay() {
    //   try {
    //     // 从localStorage获取录音数据
    //     var audioData = JSON.parse(localStorage.getItem(this.refName));
    //     if (audioData) {
    //       // 创建audio元素并设置属性
    //       var audio = document.createElement("audio");
    //       audio.controls = true;
    //       document.body.appendChild(audio);

    //       // 直接使用存储的URL设置audio的src
    //       audio.src = audioData.src;

    //       // 播放音频
    //       audio.play()
    //         audio.addEventListener('ended', () => {
    //           console.log(audio.src,'audio.src结束了。。。。。。。')
    //           URL.revokeObjectURL(audio.src);
    //         });
    //       // 更新音频时长显示
    //       this.audioDuration = audioData.duration;
    //     } else {
    //       console.error("未找到录音数据");
    //     }
    //   } catch (error) {
    //     console.error("处理录音播放时出错：", error);
    //   }
    // },
    // 重置
    reset(type) {
      // 如果类型未指定，则不需要清除特定状态（如toast），直接进行录音资源的重置
      if (this.rec) {
        // 关闭录音并释放相关资源
        this.rec.close();
        // 重置录音对象和状态标志
        this.rec = null;
        this.isStop = false;
        this.isSound = false;
        // 可以在此处添加其他需要的重置逻辑
      }
      // 注意：如果其他组件或逻辑依赖于这里的type检查来执行额外的重置操作，
      // 那么应该保留对type的检查，并在这里或其他地方添加相应的逻辑。
    },
  },
};
</script>
<style lang="scss" scoped>
i {
  color: #707070;
  font-size: 26px;
}
.audio_btn {
  width: 127px;
  height: 27px;
  cursor: pointer;
  margin-bottom: 2px;
  margin-left: 100px;
  background: pink;
  text-align: center;
}
</style>